import React from "react";

interface BrandMarkProps {
  className?: string;
}

/**
 * Header wordmark, matching PeakPWA: Space Grotesk "PEAK" with a bold
 * primary caret, pulled tight with -ml-1.
 */
const BrandMark: React.FC<BrandMarkProps> = ({ className = "" }) => {
  return (
    <span
      className={`text-3xl font-groteskLogo font-bold leading-none text-base-content ${className}`}
    >
      PEAK
      <span className="font-bold text-primary -ml-1">^</span>
    </span>
  );
};

export default BrandMark;
